var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineStore } from "pinia";
import { toPromise } from "src/shared/api/promise";
import UserEndpoints from "src/shared/api/user/UserEndpoints";
import _ from "underscore";
import { reactive } from "vue";
import User from "./model/User";
export const useUserStore = defineStore("userStore", () => {
    const state = reactive({});
    const setUsers = (userResponses) => {
        _.chain(userResponses)
            .map((response) => new User(response))
            .forEach((user) => {
            state[user.user_id] = user;
        });
    };
    const fetchUsers = (scope, headerName) => __awaiter(void 0, void 0, void 0, function* () {
        setUsers(yield toPromise(UserEndpoints.getAll(scope, headerName)));
    });
    const fetchUser = (userId, headerName) => __awaiter(void 0, void 0, void 0, function* () {
        if (!userId) {
            return;
        }
        setUsers([yield toPromise(UserEndpoints.get(userId, headerName))]);
    });
    const getUsers = () => _.values(state);
    const getUser = (userId) => {
        if (!userId) {
            return undefined;
        }
        return state[userId];
    };
    const createUser = (data) => __awaiter(void 0, void 0, void 0, function* () {
        const user = yield toPromise(UserEndpoints.create(data));
        setUsers([user]);
        return user;
    });
    const updateUser = (userId, data) => __awaiter(void 0, void 0, void 0, function* () {
        setUsers([yield toPromise(UserEndpoints.update(userId, data))]);
    });
    const deleteUser = (userId) => __awaiter(void 0, void 0, void 0, function* () {
        yield toPromise(UserEndpoints.archive(userId));
        delete state[userId];
    });
    const resendPasswordEmail = (email) => __awaiter(void 0, void 0, void 0, function* () {
        yield toPromise(UserEndpoints.resetPassword({
            email,
        }));
    });
    const unlockUser = (userId) => __awaiter(void 0, void 0, void 0, function* () {
        yield toPromise(UserEndpoints.unlock(userId));
        yield fetchUser(userId, "unlockUser");
    });
    return {
        state,
        fetchUsers,
        fetchUser,
        getUser,
        getUsers,
        createUser,
        updateUser,
        deleteUser,
        resendPasswordEmail,
        unlockUser,
    };
});
